import React from 'react'; 
import {Glyphicon} from 'react-bootstrap';
import {FormattedDate, FormattedTime} from 'react-intl';
import {isSameDate} from '../common_components/date_functions.js'


export default function ActivityDate({activity}){ 
  return(
    <div className="">
      <Glyphicon glyph="calendar" />&nbsp;&nbsp;
      <FormattedDate value={activity.startDate}/>&nbsp;
      <FormattedTime value={activity.startDate} hour12={true} />
      &nbsp; -
      {renderFinishDate(activity)}
      <FormattedTime value={activity.finishDate} hour12={true} />        
    </div>
  );
}

function renderFinishDate(activity){
  let element = <span>&nbsp;&nbsp;</span>
  if( !isSameDate(activity.startDate, activity.finishDate) ){
    element = <span>&nbsp;&nbsp;<FormattedDate value={activity.finishDate}/>&nbsp;</span>
  }
  return element;
}